import { render } from "./unorganizedGovernance.vue?vue&type=template&id=11f36d43&scoped=true"
import script from "./unorganizedGovernance.vue?vue&type=script&lang=js"
export * from "./unorganizedGovernance.vue?vue&type=script&lang=js"

import "./unorganizedGovernance.vue?vue&type=style&index=0&id=11f36d43&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f36d43"]])

export default __exports__